import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const u = await api.processSession(sessionId);
        setUser(u);
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      } catch (e) {
        window.location.replace("/");
      }
    })();
  }, [location.hash, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 text-slate-500 font-body">
      <div className="h-8 w-8 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
      جارٍ تسجيل الدخول...
    </div>
  );
}
